//function onePageScroll(e,t){var n={sectionContainer:"section",easing:"ease",animationTime:1e3,pagination:true,updateURL:false,keyboard:true,beforeMove:null,afterMove:null,loop:false,responsiveFallback:false},r=this,i=Object.extend({},n,t),s=document.querySelector(e),o=document.querySelectorAll(i.sectionContainer),u=o.length,a="off",f=0,l=0,c=500,h="",p=document.querySelector("body");this.init=function(){_addClass(s,"onepage-wrapper");s.style.position="relative";for(var e=0;e<o.length;e++){_addClass(o[e],"ops-section");o[e].dataset.index=e+1;f=f+100;if(i.pagination==true){h+="<li><a data-index='"+(e+1)+"' href='#"+(e+1)+"'></a></li>"}}_swipeEvents(s);document.addEventListener("swipeDown",function(e){if(!_hasClass(p,"disabled-onepage-scroll"))e.preventDefault();moveUp(s)});document.addEventListener("swipeUp",function(e){if(!_hasClass(p,"disabled-onepage-scroll"))e.preventDefault();moveDown(s)});if(i.pagination==true){var t=document.createElement("ul");t.setAttribute("class","onepage-pagination");p.appendChild(t);t.innerHTML=h;var n=document.querySelector(".onepage-pagination").offsetHeight/2*-1;document.querySelector(".onepage-pagination").style.marginTop=n}if(window.location.hash!=""&&window.location.hash!="#1"){var r=window.location.hash.replace("#",""),u=document.querySelector(i.sectionContainer+"[data-index='"+r+"']"),a=u.dataset.index;_addClass(document.querySelector(i.sectionContainer+"[data-index='"+r+"']"),"active");_addClass(p,"viewing-page-"+r);if(i.pagination==true)_addClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+r+"']"),"active");if(u){_addClass(u,"active");if(i.pagination==true)_addClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+r+"']"),"active");p.className=p.className.replace(/\bviewing-page-\d.*?\b/g,"");_addClass(p,"viewing-page-"+a);if(history.replaceState&&i.updateURL==true){var l=window.location.href.substr(0,window.location.href.indexOf("#"))+"#"+r;history.pushState({},document.title,l)}}var c=(r-1)*100*-1;_transformPage(s,i,c,r)}else{_addClass(document.querySelector(i.sectionContainer+"[data-index='1']"),"active");_addClass(p,"viewing-page-1");if(i.pagination==true)_addClass(document.querySelector(".onepage-pagination li a[data-index='1']"),"active")}_paginationHandler=function(){var e=this.dataset.index;moveTo(s,e)};if(i.pagination==true){var d=document.querySelectorAll(".onepage-pagination li a");for(var e=0;e<d.length;e++){d[e].addEventListener("click",_paginationHandler)}}_mouseWheelHandler=function(e){e.preventDefault();var t=e.wheelDelta||-e.detail;if(!_hasClass(p,"disabled-onepage-scroll"))_init_scroll(e,t)};/*document.addEventListener("mousewheel",_mouseWheelHandler);document.addEventListener("DOMMouseScroll",_mouseWheelHandler);*/if(i.responsiveFallback!=false){window.onresize=function(){_responsive()};_responsive()}_keydownHandler=function(e){var t=e.target.tagName.toLowerCase();if(!_hasClass(p,"disabled-onepage-scroll")){switch(e.which){case 38:if(t!="input"&&t!="textarea")moveUp(s);break;case 40:if(t!="input"&&t!="textarea")moveDown(s);break;default:return}}return false};if(i.keyboard==true){document.onkeydown=_keydownHandler}return false};_swipeEvents=function(e){function r(e){var r=e.touches;if(r&&r.length){t=r[0].pageX;n=r[0].pageY;document.addEventListener("touchmove",i)}}function i(e){var r=e.touches;if(r&&r.length){e.preventDefault();var s=t-r[0].pageX;var o=n-r[0].pageY;if(s>=50){var e=new Event("swipeLeft");document.dispatchEvent(e)}if(s<=-50){var e=new Event("swipeRight");document.dispatchEvent(e)}if(o>=50){var e=new Event("swipeUp");document.dispatchEvent(e)}if(o<=-50){var e=new Event("swipeDown");document.dispatchEvent(e)}if(Math.abs(s)>=50||Math.abs(o)>=50){document.removeEventListener("touchmove",i)}}}var t,n;document.addEventListener("touchstart",r)};_trim=function(e){return e.replace(/^\s\s*/,"").replace(/\s\s*$/,"")};_hasClass=function(e,t){if(e.className){return e.className.match(new RegExp("(\\s|^)"+t+"(\\s|$)"))}else{return e.className=t}};_addClass=function(e,t){if(!_hasClass(e,t))e.className+=" "+t;e.className=_trim(e.className)};_removeClass=function(e,t){if(_hasClass(e,t)){var n=new RegExp("(\\s|^)"+t+"(\\s|$)");e.className=e.className.replace(n," ")}e.className=_trim(e.className)};_whichTransitionEvent=function(){var e;var t=document.createElement("fakeelement");var n={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in n){if(t.style[e]!==undefined){return n[e]}}};_scrollTo=function(e,t,n){if(n<0)return;var r=t-e.scrollTop;var i=r/n*10;setTimeout(function(){e.scrollTop=e.scrollTop+i;if(e.scrollTop==t)return;_scrollTo(e,t,n-10)},10)};_transformPage=function(e,t,n,r,i){function u(){if(typeof t.afterMove=="function")t.afterMove(r,i);e.removeEventListener(o,u)}if(typeof t.beforeMove=="function")t.beforeMove(r,i);var s="-webkit-transform: translate3d(0, "+n+"%, 0); -webkit-transition: -webkit-transform "+t.animationTime+"ms "+t.easing+"; -moz-transform: translate3d(0, "+n+"%, 0); -moz-transition: -moz-transform "+t.animationTime+"ms "+t.easing+"; -ms-transform: translate3d(0, "+n+"%, 0); -ms-transition: -ms-transform "+t.animationTime+"ms "+t.easing+"; transform: translate3d(0, "+n+"%, 0); transition: transform "+t.animationTime+"ms "+t.easing+";";e.style.cssText=s;var o=_whichTransitionEvent();e.addEventListener(o,u,false)};_responsive=function(){if(document.body.clientWidth<i.responsiveFallback){_addClass(p,"disabled-onepage-scroll");/*document.removeEventListener("mousewheel",_mouseWheelHandler);document.removeEventListener("DOMMouseScroll",_mouseWheelHandler);*/_swipeEvents(s);document.removeEventListener("swipeDown");document.removeEventListener("swipeUp")}else{if(_hasClass(p,"disabled-onepage-scroll")){_removeClass(p,"disabled-onepage-scroll");_scrollTo(document.documentElement,0,2e3)}_swipeEvents(s);document.addEventListener("swipeDown",function(e){if(!_hasClass(p,"disabled-onepage-scroll"))e.preventDefault();moveUp(s)});document.addEventListener("swipeUp",function(e){if(!_hasClass(p,"disabled-onepage-scroll"))e.preventDefault();moveDown(s)});/*document.addEventListener("mousewheel",_mouseWheelHandler);document.addEventListener("DOMMouseScroll",_mouseWheelHandler)*/}};_init_scroll=function(e,t){var n=t,r=(new Date).getTime();if(r-l<c+i.animationTime){e.preventDefault();return}if(n<0){moveDown(s)}else{moveUp(s)}l=r};this.moveDown=function(e){if(typeof e=="string")e=document.querySelector(e);var t=document.querySelector(i.sectionContainer+".active").dataset.index,n=document.querySelector(i.sectionContainer+"[data-index='"+t+"']"),r=document.querySelector(i.sectionContainer+"[data-index='"+(parseInt(t)+1)+"']");if(!r){if(i.loop==true){pos=0;r=document.querySelector(i.sectionContainer+"[data-index='1']")}else{return}}else{pos=t*100*-1}var s=r.dataset.index;_removeClass(n,"active");_addClass(r,"active");if(i.pagination==true){_removeClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+t+"']"),"active");_addClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+s+"']"),"active")}p.className=p.className.replace(/\bviewing-page-\d.*?\b/g,"");_addClass(p,"viewing-page-"+s);if(history.replaceState&&i.updateURL==true){var o=window.location.href.substr(0,window.location.href.indexOf("#"))+"#"+(parseInt(t)+1);history.pushState({},document.title,o)}_transformPage(e,i,pos,s,r)};this.moveUp=function(e){if(typeof e=="string")e=document.querySelector(e);var t=document.querySelector(i.sectionContainer+".active").dataset.index,n=document.querySelector(i.sectionContainer+"[data-index='"+t+"']"),r=document.querySelector(i.sectionContainer+"[data-index='"+(parseInt(t)-1)+"']");if(!r){if(i.loop==true){pos=(u-1)*100*-1;r=document.querySelector(i.sectionContainer+"[data-index='"+u+"']")}else{return}}else{pos=(r.dataset.index-1)*100*-1}var s=r.dataset.index;_removeClass(n,"active");_addClass(r,"active");if(i.pagination==true){_removeClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+t+"']"),"active");_addClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+s+"']"),"active")}p.className=p.className.replace(/\bviewing-page-\d.*?\b/g,"");_addClass(p,"viewing-page-"+s);if(history.replaceState&&i.updateURL==true){var o=window.location.href.substr(0,window.location.href.indexOf("#"))+"#"+(parseInt(t)-1);history.pushState({},document.title,o)}_transformPage(e,i,pos,s,r)};this.moveTo=function(e,t){if(typeof e=="string")e=document.querySelector(e);var n=document.querySelector(i.sectionContainer+".active"),r=document.querySelector(i.sectionContainer+"[data-index='"+t+"']");if(r){var s=r.dataset.index;_removeClass(n,"active");_addClass(r,"active");_removeClass(document.querySelector(".onepage-pagination li a"+".active"),"active");_addClass(document.querySelector(".onepage-pagination li a"+"[data-index='"+t+"']"),"active");p.className=p.className.replace(/\bviewing-page-\d.*?\b/g,"");_addClass(p,"viewing-page-"+s);pos=(t-1)*100*-1;if(history.replaceState&&i.updateURL==true){var o=window.location.href.substr(0,window.location.href.indexOf("#"))+"#"+(parseInt(t)-1);history.pushState({},document.title,o)}_transformPage(e,i,pos,t,r)}};this.init()}Object.extend=function(e){if(e==null)return e;for(var t=1;t<arguments.length;t++){var n=arguments[t];if(n!=null){for(var r in n){var i=n.__lookupGetter__(r),s=n.__lookupSetter__(r);if(i||s){if(i)e.__defineGetter__(r,i);if(s)e.__defineSetter__(r,s)}else{e[r]=n[r]}}}}return e}


/* ===========================================================
 * onepagescroll.js v1.2.2
 * ===========================================================
 * Copyright 2014 Pete Rojwongsuriya.
 * http://www.thepetedesign.com
 *
 * Create an Apple-like website that let user scroll
 * one page at a time
 *
 * Credit: Eike Send for the awesome swipe event
 * https://github.com/peachananr/purejs-onepage-scroll
 * 
 * License: GPL v3
 *
 * ========================================================== */
	
;function onePageScroll(element, options) {
  
  var defaults = {
	    	sectionContainer: "section",
	    	easing: "ease",
	    	animationTime: 1000,
	    	pagination: true,
	    	updateURL: false,
	    	keyboard: true,
	    	beforeMove: null,
	    	afterMove: null,
	    	loop: false,
	    	responsiveFallback: false
	    },
	    _root = this,
	    settings = Object.extend({}, defaults, options),
	    el = document.querySelector(element),
	    sections = document.querySelectorAll(settings.sectionContainer),
	    total = sections.length,
	    status = "off",
	    topPos = 0,
	    lastAnimation = 0,
	    quietPeriod = 500,
	    paginationList = "",
	    body = document.querySelector("body");
  
  this.init = function() { 
    /*-------------------------------------------*/
    /*  Prepare Everything                       */
    /*-------------------------------------------*/
    
  	_addClass(el, "onepage-wrapper")
  	el.style.position = "relative";
    
  	for( var i = 0; i < sections.length; i++){
  	  _addClass(sections[i], "ops-section")
  	  sections[i].dataset.index = i + 1;
  	  topPos = topPos + 100;
    
  	  if(settings.pagination == true) {
  			paginationList += "<li><a data-index='" + (i + 1) + "' href='#" + (i + 1) + "'></a></li>";
  		}
    }
    
  	_swipeEvents(el);
  	document.addEventListener("swipeDown",  function(event){
  	  if (!_hasClass(body, "disabled-onepage-scroll")) event.preventDefault();
  		moveUp(el);
  	});
  	document.addEventListener("swipeUp", function(event){
  		if (!_hasClass(body, "disabled-onepage-scroll")) event.preventDefault();
  		moveDown(el);
  	});
    
  	// Create Pagination and Display Them
    
  	if(settings.pagination == true) {
  	  var pagination = document.createElement("ul");
  	  pagination.setAttribute("class", "onepage-pagination");
    
  	  body.appendChild(pagination)
  		pagination.innerHTML = paginationList;
  		var posTop = (document.querySelector(".onepage-pagination").offsetHeight / 2) * -1;
  		document.querySelector(".onepage-pagination").style.marginTop = posTop;
  	}
    
  	if(window.location.hash != "" && window.location.hash != "#1") {
  		var init_index =  window.location.hash.replace("#", ""),
  		    next = document.querySelector(settings.sectionContainer + "[data-index='" + (init_index) + "']"),
  		    next_index = next.dataset.index;
    
  		_addClass( document.querySelector(settings.sectionContainer + "[data-index='" + init_index + "']") ,"active")
  		_addClass(body, "viewing-page-"+ init_index)
  		if(settings.pagination == true) _addClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + init_index + "']"), "active");
    
  		if(next) {
  			_addClass(next, "active")
  			if(settings.pagination == true) _addClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + init_index + "']"), "active");
    
  			body.className = body.className.replace(/\bviewing-page-\d.*?\b/g, '');
  			_addClass(body, "viewing-page-" + next_index)
  			if (history.replaceState && settings.updateURL == true) {
  				var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (init_index);
  				history.pushState( {}, document.title, href );
  			}
  		}
  		var pos = ((init_index - 1) * 100) * -1;
  		_transformPage(el, settings, pos, init_index);
    
  	}else{
  	  _addClass(document.querySelector(settings.sectionContainer + "[data-index='1']"), "active");
  	  _addClass(body, "viewing-page-1");
  		if(settings.pagination == true) _addClass(document.querySelector(".onepage-pagination li a[data-index='1']"), "active");
  	}
    
  	_paginationHandler = function() {
      var page_index = this.dataset.index;
  		moveTo(el, page_index);
  	}
    
    
  	if(settings.pagination == true)  {
  	  var pagination_links = document.querySelectorAll(".onepage-pagination li a");
    
  	  for( var i = 0; i < pagination_links.length; i++){
    	  pagination_links[i].addEventListener('click', _paginationHandler);
      }
  	}
    
  	_mouseWheelHandler = function(event) {
  		event.preventDefault();
  		var delta = event.wheelDelta || -event.detail;
  		if (!_hasClass(body, "disabled-onepage-scroll")) _init_scroll(event, delta);
  	}
    
  	document.addEventListener('mousewheel', _mouseWheelHandler);
  	document.addEventListener('DOMMouseScroll', _mouseWheelHandler);
    
    
  	if(settings.responsiveFallback != false) {
  	  window.onresize = function(){
  			_responsive();
  		}
    
  		_responsive();
  	}
    
    _keydownHandler = function(e) {
  		var tag = e.target.tagName.toLowerCase();
    
  		if (!_hasClass(body, "disabled-onepage-scroll")) {
  			switch(e.which) {
  				case 38:
  					if (tag != 'input' && tag != 'textarea') moveUp(el)
  					break;
  				case 40:
  					if (tag != 'input' && tag != 'textarea') moveDown(el)
  					break;
  				default: return;
  			}
  		}
  		return false;
  	}
    
  	if(settings.keyboard == true) {
  		document.onkeydown = _keydownHandler;
  	}
  	return false;
  }
  
  /*-------------------------------------------------------*/
  /*  Private Functions                                    */
  /*-------------------------------------------------------*/
  /*------------------------------------------------*/
  /*  Credit: Eike Send for the awesome swipe event */
  /*------------------------------------------------*/
  _swipeEvents = function(el){
  	var startX,
  		startY;
  
    document.addEventListener("touchstart", touchstart);  
  
  	function touchstart(event) {
  		if (!_hasClass(body, "disabled-onepage-scroll")) {
  			var touches = event.touches;
  			if (touches && touches.length) {
  				startX = touches[0].pageX;
  				startY = touches[0].pageY;
  				document.addEventListener("touchmove", touchmove);
  			}
  		}
  	}
  
  	function touchmove(event) {
  		if (!_hasClass(body, "disabled-onepage-scroll")) {
	  		var touches = event.touches;
	  		if (touches && touches.length) {
	  		  event.preventDefault();
	  			var deltaX = startX - touches[0].pageX;
	  			var deltaY = startY - touches[0].pageY;
	  
	  			if (deltaX >= 50) {
	  			  var event = new Event('swipeLeft');
	  			  document.dispatchEvent(event);
	  			}
	  			if (deltaX <= -50) {
	  			  var event = new Event('swipeRight');
	  			  document.dispatchEvent(event);
	  			}
	  			if (deltaY >= 50) {
	  			  var event = new Event('swipeUp');
	  			  document.dispatchEvent(event);
	  			}
	  			if (deltaY <= -50) {
	  			  var event = new Event('swipeDown');
	  			  document.dispatchEvent(event);
	  			}
	  
	  			if (Math.abs(deltaX) >= 50 || Math.abs(deltaY) >= 50) {
	  				document.removeEventListener('touchmove', touchmove);
	  			}
	  		}
  		}
  	}
  
  };
  /*-----------------------------------------------------------*/
	/*  Utility to add/remove class easily with javascript       */
	/*-----------------------------------------------------------*/

  _trim = function(str) {
      return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  _hasClass = function(ele,cls) {
    if (ele.className) {
      return ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
    } else {
      return ele.className = cls;
    }
  }

  _addClass = function(ele,cls) {
    if (!_hasClass(ele,cls)) ele.className += " "+cls;
    ele.className = _trim(ele.className)
  }

  _removeClass = function(ele,cls) {
    if (_hasClass(ele,cls)) {
        var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
        ele.className=ele.className.replace(reg,' ');
    }
    ele.className = _trim(ele.className)
  }

  /*-----------------------------------------------------------*/
	/*  Transtionend Normalizer by Modernizr                     */
	/*-----------------------------------------------------------*/

  _whichTransitionEvent = function(){
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    }

    for(t in transitions){
        if( el.style[t] !== undefined ){
            return transitions[t];
        }
    }
  }

  /*-----------------------------------------------------------*/
	/*  Function to perform scroll to top animation              */
	/*-----------------------------------------------------------*/

  _scrollTo = function(element, to, duration) {
    if (duration < 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;

    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop == to) return;
        _scrollTo(element, to, duration - 10);
    }, 10);
  }
  
  
     
  /*---------------------------------*/
  /*  Function to transform the page */
  /*---------------------------------*/
  
  _transformPage = function(el2, settings, pos, index, next_el) {
    if (typeof settings.beforeMove == 'function') settings.beforeMove(index, next_el);
    
    var transformCSS = "-webkit-transform: translate3d(0, " + pos + "%, 0); -webkit-transition: -webkit-transform " + settings.animationTime + "ms " + settings.easing + "; -moz-transform: translate3d(0, " + pos + "%, 0); -moz-transition: -moz-transform " + settings.animationTime + "ms " + settings.easing + "; -ms-transform: translate3d(0, " + pos + "%, 0); -ms-transition: -ms-transform " + settings.animationTime + "ms " + settings.easing + "; transform: translate3d(0, " + pos + "%, 0); transition: transform " + settings.animationTime + "ms " + settings.easing + ";";
    
    el2.style.cssText = transformCSS;
    
    var transitionEnd = _whichTransitionEvent();
     el2.addEventListener(transitionEnd, endAnimation, false);
    
    function endAnimation() {
      if (typeof settings.afterMove == 'function') settings.afterMove(index, next_el);
      el2.removeEventListener(transitionEnd, endAnimation)
    }
  }
  
  /*-------------------------------------------*/
  /*  Responsive Fallback trigger              */
  /*-------------------------------------------*/
  
  _responsive = function() {

		if (document.body.clientWidth < settings.responsiveFallback) {
			
			_addClass(body, "disabled-onepage-scroll");
			document.removeEventListener('mousewheel', _mouseWheelHandler);
			document.removeEventListener('DOMMouseScroll', _mouseWheelHandler);
			_swipeEvents(el);
			//document.removeEventListener("swipeDown");
			//document.removeEventListener("swipeUp");
			
		} else {
		  
		  if (_hasClass(body, "disabled-onepage-scroll")) {
		    _removeClass(body, "disabled-onepage-scroll");
		    _scrollTo(document.documentElement, 0, 2000);
	    }
      
      

			_swipeEvents(el);
			document.addEventListener("swipeDown",  function(event){
			  if (!_hasClass(body, "disabled-onepage-scroll")) event.preventDefault();
				moveUp(el);
			});
			document.addEventListener("swipeUp", function(event){
				if (!_hasClass(body, "disabled-onepage-scroll")) event.preventDefault();
				moveDown(el);
			});
      
      document.addEventListener('mousewheel', _mouseWheelHandler);
  		document.addEventListener('DOMMouseScroll', _mouseWheelHandler);
			
		}
	}
	
	/*-------------------------------------------*/
  /*  Initialize scroll detection              */
  /*-------------------------------------------*/
  
  _init_scroll = function(event, delta) {
		var deltaOfInterest = delta,
			timeNow = new Date().getTime();
			
		// Cancel scroll if currently animating or within quiet period
		if(timeNow - lastAnimation < quietPeriod + settings.animationTime) {
			event.preventDefault();
			return;
		}

		if (deltaOfInterest < 0) {
			moveDown(el)
		} else {
			moveUp(el)
		}
		
		lastAnimation = timeNow;
	}
   
  
  /*-------------------------------------------------------*/
  /*  Public Functions                                     */
  /*-------------------------------------------------------*/
  
  /*---------------------------------*/
  /*  Function to move down section  */
  /*---------------------------------*/
  
   this.moveDown = function(el3) {
    
    if (typeof el3 == "string") el3 = document.querySelector(el3);
    
    var index = document.querySelector(settings.sectionContainer +".active").dataset.index,
		    current = document.querySelector(settings.sectionContainer + "[data-index='" + index + "']"),
		    next = document.querySelector(settings.sectionContainer + "[data-index='" + (parseInt(index) + 1) + "']");
		    
		    
		if(!next) {
			if (settings.loop == true) {
				pos = 0;
				next = document.querySelector(settings.sectionContainer + "[data-index='1']");
			} else {
				return
			}

		}else {
			pos = (index * 100) * -1;
		}
		var next_index = next.dataset.index;
		_removeClass(current, "active");
		_addClass(next, "active");
		
		if(settings.pagination == true) {
		  _removeClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + index + "']"), "active");
		  _addClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + next_index + "']"), "active");
		}

		body.className = body.className.replace(/\bviewing-page-\d.*?\b/g, '');
		_addClass(body, "viewing-page-"+ next_index);

		if (history.replaceState && settings.updateURL == true) {
			var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (parseInt(index) + 1);
			history.pushState( {}, document.title, href );
		}
		_transformPage(el3, settings, pos, next_index, next);
	}
	
	/*---------------------------------*/
  /*  Function to move up section    */
  /*---------------------------------*/
	
	this.moveUp = function(el4) {
	  
	  if (typeof el4 == "string") el4 = document.querySelector(el4);
	  
	  var index = document.querySelector(settings.sectionContainer +".active").dataset.index,
		    current = document.querySelector(settings.sectionContainer + "[data-index='" + index + "']"),
		    next = document.querySelector(settings.sectionContainer + "[data-index='" + (parseInt(index) - 1) + "']");

		if(!next) {
			if (settings.loop == true) {
				pos = ((total - 1) * 100) * -1;
				next = document.querySelector(settings.sectionContainer + "[data-index='" + total + "']");
			} else {
				return
			}
		}else {
			pos = ((next.dataset.index - 1) * 100) * -1;
		}
		var next_index = next.dataset.index;
		_removeClass(current, "active")
		_addClass(next, "active")
		
		if(settings.pagination == true) {
		  _removeClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + index + "']"), "active");
		  _addClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + next_index + "']"), "active");
		}
		body.className = body.className.replace(/\bviewing-page-\d.*?\b/g, '');
		_addClass(body, "viewing-page-"+ next_index);

		if (history.replaceState && settings.updateURL == true) {
			var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (parseInt(index) - 1);
			history.pushState( {}, document.title, href );
		}
		_transformPage(el4, settings, pos, next_index, next);
	}
  
  /*-------------------------------------------*/
  /*  Function to move to specified section    */
  /*-------------------------------------------*/
  
  this.moveTo = function(el5, page_index) {
    
    if (typeof el5 == "string") el5 = document.querySelector(el5);
    
		var current = document.querySelector(settings.sectionContainer + ".active"),
		    next = document.querySelector(settings.sectionContainer + "[data-index='" + (page_index) + "']");
		    
		if(next) {
		  var next_index = next.dataset.index;
			_removeClass(current, "active");
			_addClass(next, "active");
			_removeClass(document.querySelector(".onepage-pagination li a" + ".active"), "active");
			_addClass(document.querySelector(".onepage-pagination li a" + "[data-index='" + (page_index) + "']"), "active");

			body.className = body.className.replace(/\bviewing-page-\d.*?\b/g, '');
			_addClass(body, "viewing-page-"+ next_index);

			pos = ((page_index - 1) * 100) * -1;

			if (history.replaceState && settings.updateURL == true) {
				var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (parseInt(page_index) - 1);
				history.pushState( {}, document.title, href );
			}
			_transformPage(el5, settings, pos, page_index, next);
		}
	}
	
  this.init();
}

/*------------------------------------------------*/
 /*  Ulitilities Method                            */
 /*------------------------------------------------*/
 
 /*-----------------------------------------------------------*/
 /*  Function by John Resig to replicate extend functionality */
 /*-----------------------------------------------------------*/
 
 Object.extend = function(orig){
   if ( orig == null )
     return orig;
 
   for ( var i = 1; i < arguments.length; i++ ) {
     var obj = arguments[i];
     if ( obj != null ) {
       for ( var prop in obj ) {
         var getter = obj.__lookupGetter__( prop ),
             setter = obj.__lookupSetter__( prop );
 
         if ( getter || setter ) {
           if ( getter )
             orig.__defineGetter__( prop, getter );
           if ( setter )
             orig.__defineSetter__( prop, setter );
         } else {
           orig[ prop ] = obj[ prop ];
         }
       }
     }
   }
 
   return orig;
 };
